import React from "react";
import { brandAssets } from "../data/offer";
type PageCropProps = {
  x: number;
  title: string;
  className?: string;
};

// Affiche une page réelle du Méga Pack découpée depuis la planche fournie.
export function PageCrop({
  x,
  title,
  className = ""
}: PageCropProps) {
  const {
    src,
    width,
    cardWidth,
    cardHeight,
    top
  } = brandAssets.pageSheet;
  return <div className={`relative overflow-hidden bg-cream ${className}`} style={{
    aspectRatio: `${cardWidth} / ${cardHeight}`
  }} data-id="element-191" data-mp="2a0zkgpm7ljl7">
      <img src={src} alt={`Page de la parabole « ${title} »`} loading="lazy" className="absolute max-w-none" style={{
      width: `${width / cardWidth * 100}%`,
      left: `-${x / cardWidth * 100}%`,
      top: `-${top / cardHeight * 100}%`
    }} data-id="element-192" data-mp="2jwjdn49e2469" />
    </div>;
}